import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
}), 'CropSquareTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CropSquareTwoTone.js
// module id = 3041
// module chunks = 2